import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import Router from "./Components/Router";

ReactDOM.render(<Router />, document.getElementById("root"));
